module.exports = __webpack_public_path__ + "img/md-images.16c79cf3.svg";